var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Helmet } from 'react-helmet';
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import cx from 'clsx';
import { breadcrumb } from '../utils/ld';
export var Breadcrumb = function (_a) {
    var url = _a.url, current = _a.current, hierarchies = _a.hierarchies, onLinkClick = _a.onLinkClick, LinkComponent = _a.LinkComponent, _b = _a.topTitle, topTitle = _b === void 0 ? 'よくあるご質問' : _b;
    var links = __spreadArray(__spreadArray([
        { title: topTitle, link: '/' }
    ], (hierarchies || [])
        .filter(function (_a) {
        var title = _a.title;
        return title;
    })
        .map(function (link) { return (__assign(__assign({}, link), { link: link.link || '/' })); }), true), [
        { title: current, link: '' },
    ], false);
    return (React.createElement("div", { className: cx('faq-breadcrumb') },
        React.createElement(Helmet, null,
            React.createElement("script", { type: "application/ld+json" }, JSON.stringify(breadcrumb(url, links)))),
        React.createElement(Breadcrumbs, { "arial-label": "Breadcrumb", separator: '>', maxItems: 5 }, links.map(function (_a, index) {
            var title = _a.title, link = _a.link;
            var linkProps = { href: link };
            if (LinkComponent) {
                var LinkC = React.forwardRef(function LinkC(p, ref) {
                    return (React.createElement(LinkComponent, __assign({}, p, { ref: ref, to: link, state: { hierarchies: links.slice(1, index) } })));
                });
                linkProps.component = LinkC;
            }
            if (onLinkClick) {
                linkProps.onClick = function (e) {
                    e.preventDefault();
                    if (onLinkClick && link) {
                        var options = index === 0 ? {} : { state: { hierarchies: links.slice(1, index) } };
                        onLinkClick(link, options);
                    }
                };
            }
            return link ? (React.createElement(Link, __assign({ key: link, color: "inherit" }, linkProps), title)) : (React.createElement(Typography, { key: link, color: "textPrimary" }, title));
        }))));
};
//# sourceMappingURL=Breadcrumb.js.map